
const LoadingFallback = () => {
  return null;
};

export default LoadingFallback;
